<template>
  <div>
    <router-view />
    <notifications class="notification" group="base" position="bottom right" />
  </div>
</template>

<script>
export default {
  name: "App",
  data: () => ({}),
  computed: {
    user() {
      return this.$store.getters["user/getUser"];
    },
  },
};
</script>

<style lang="scss">
.notification {
  font-family: Roboto, Verdana, Geneva, Tahoma, sans-serif;
  .notification-title {
    padding-bottom: 5px;
    letter-spacing: 1px;
    font-size: 16px;
  }
  .notification-content {
    font-size: 14px;
  }

  &.leffe {
    background: orange;
  }
}
</style>